import {
    ContentApi as ContentServiceApi,
    Configuration,
    V2Api as CollectionApi,
    GroupApi as ContentServiceGroupApi,
} from '@videoblocks/content-service-client';

import ContentServiceClient from './src/ContentServiceClient';
import { ContentClassEnum, ContentHistory } from './src/types';

const { CONTENT_HOST = 'http://localhost:9500' } = process.env;

const configuration = new Configuration({
    basePath: CONTENT_HOST,
});

const contentApi = new ContentServiceApi(configuration);
const collectionApi = new CollectionApi(configuration);
const groupApi = new ContentServiceGroupApi(configuration);

export { ContentClassEnum, type ContentHistory };

const contentServiceClient = new ContentServiceClient(collectionApi, contentApi, groupApi);
export default contentServiceClient;

export * from './src/serverActions';
